/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Container, Row, Col, FormGroup, FormLabel, FormControl, Form, Button }
         from 'react-bootstrap';
import Table from './Table';
import { updateComponent, getFromJson, post } from '../util/Utils'
import '../css/lak.css';
import { AlertLevel } from '../App';
import PropTypes from 'prop-types';


export const LAK_HINT = 'To enter a new license key, paste it here and click "Save"'


function makeTableData(state) {
    let rows = []
    let lak = getFromJson(state, ['data', 'data', 'lak'])
    if (lak) {
        rows.push(['Product', lak.product])
        rows.push(['Platform', lak.platform])
        rows.push(['Units', lak.units])
        rows.push(['Options', lak.options])
        rows.push(['Licensee', lak.licensee])
        rows.push(['Serial', lak.serial])
        rows.push(['Issued', lak.issued])
        rows.push(['Expires', lak.expires])
    }
    return {
        columns: ['Key', 'Value'],
        data: rows
    }
}


/**
 * Lak page of web monitor.
 */
export default class Lak extends Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.updateLak = this.updateLak.bind(this)
        this.save = this.save.bind(this)
        this.columnClasses = this.columnClasses.bind(this)
    }


    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired
    };


    async componentDidMount() {
        this.props.setRefresh(undefined)
        await updateComponent(this, '/enterLak')
    }


    /**
     * Updates the LAK input field.
     * 
     * @param event
     *      the event triggered by changing the input text.
     */
    updateLak(event) {
        this.setState({
            lak: event.target.value
        })
    }


    /**
     * Saves LAK on PowerMTA.
     * 
     * @param event
     *      the event triggered by submitting the form.
     */
    async save(event) {
        event.preventDefault()
        return post(this, '/enterLak', {
            license: this.state.lak
        }, true, () => {
            this.props.showError(this.state.successMessage, AlertLevel.SUCCESS)
        })
    }


    columnClasses(cell, row, rowIndex, colIndex) {
        return colIndex === 0 ? 'lakKey' : 'lakValue'
    }


    render() {
        let table = makeTableData(this.state)
        return (
            <Container>
                <Row>
                    <Col md={12}>{
                        <Table id='lakProperties'
                               columns={table.columns}
                               data={table.data}
                               caption='Current License Key'
                               hideColumnTitles={true}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div className='center'>
                            <Form onSubmit={this.save}>
                                <FormGroup>
                                    <FormLabel>
                                        New LAK
                                    </FormLabel>
                                    <FormControl as='textarea'
                                        placeholder={LAK_HINT}
                                        value={this.state.lak}
                                        onChange={this.updateLak}
                                        className='lakInput'/>
                                </FormGroup>
                                <FormGroup className="center">
                                    <Button bsPrefix='button' type='submit'>
                                        Save
                                    </Button>
                                </FormGroup>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}
